import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

// import {getEntity} from "../../../services/entity/entity-service";

import PlayerCard from '../../components/player-card/player-card';

import { resetPlayerState } from '../../../modules/player';
import { getArchivedPlayers, unarchivePlayer, getAssignedArchivedPlayers } from '../../../modules/player_api';
import { getSkills } from '../../../modules/system/skill';
import { setPageTitle } from '../../../modules/application/pages';

import './player-archive.css';

class PlayerArchive extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayName: null,
      therapistId: null,
      therapistPlayers: [],
      archivedPlayers: [],
      assignedArchivedPlayers: [],
      shouldGetArchivePlayers: true,
    };

    this.unarchivePlayer = this.unarchivePlayer.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(setPageTitle(`${this.props.currentUserFirstName}'s Archive`));
    this.props.dispatch(getSkills());
    this.props.dispatch(resetPlayerState());
  }

  async componentDidUpdate() {
    const { currentUserId, players, currentUserFirstName } = this.props;
    const { therapistId, therapistPlayers, displayName, shouldGetArchivePlayers } = this.state;

    if (currentUserFirstName !== displayName) {
      this.props.dispatch(setPageTitle(`${this.props.currentUserFirstName}'s Archive`));
      this.setState({ displayName: currentUserFirstName });
    }

    if (shouldGetArchivePlayers) {
      this.setState({
        shouldGetArchivePlayers: false,
      });
      let archivedPlayers = [];
      let assignedArchivedPlayers = [];
      const archivedPlayersResponse = await getArchivedPlayers();

      if (archivedPlayersResponse && archivedPlayersResponse.data && archivedPlayersResponse.data.success) {
        archivedPlayers = archivedPlayersResponse.data.players;
      }

      const assignedArchivedPlayersResponse = await getAssignedArchivedPlayers();

      if (
        assignedArchivedPlayersResponse &&
        assignedArchivedPlayersResponse.data &&
        assignedArchivedPlayersResponse.data.success
      ) {
        assignedArchivedPlayers = assignedArchivedPlayersResponse.data.players;
      }

      this.setState({ archivedPlayers: archivedPlayers, assignedArchivedPlayers: assignedArchivedPlayers });
    }

    if (currentUserId !== therapistId) {
      this.setState({ therapistId: currentUserId });
    }

    if (players !== therapistPlayers) {
      this.setState({ therapistPlayers: players });
    }
  }

  render() {
    const assignedArchivedPlayers = this.state.assignedArchivedPlayers;
    const archivedPlayers = this.state.archivedPlayers;

    return (
      <div>
        <Row className="ml-1 mr-2 mt-3">
          {archivedPlayers &&
            archivedPlayers.map((player) => (
              <Col md="6" className="pr-2" key={player.id}>
                <PlayerCard
                  player={player}
                  skills={this.props.skills}
                  isArchive={true}
                  archivePlayer={this.unarchivePlayer}
                />
                <br />
              </Col>
            ))}
        </Row>

        {assignedArchivedPlayers && assignedArchivedPlayers.length > 0 && (
          <div className="assigned_archived_players_section_title">Assigned Players</div>
        )}

        <Row className="ml-1 mr-2 mt-3">
          {this.state.assignedArchivedPlayers &&
            this.state.assignedArchivedPlayers.map((player) => (
              <Col md="6" className="pr-2" key={player.id}>
                <PlayerCard
                  player={player}
                  skills={this.props.skills}
                  isArchive={true}
                  archivePlayer={this.unarchivePlayer}
                />
                <br />
              </Col>
            ))}
        </Row>
      </div>
    );
  }

  async unarchivePlayer(playerId) {
    await unarchivePlayer(playerId);
    this.props.history.push(`/therapistDashboard?message=Unarchived player!`);
  }
}

const withState = connect((state) => {
  const { user, player, skill } = state;

  return {
    players: player.players,
    filter: player.filters,
    currentUserId: user.currentUserId,
    currentUserFirstName: user.currentUserFirstName,
    skills: skill.skills,
  };
});
export default withRouter(withState(PlayerArchive));
